var map = {
	"./avito.svg": 96025,
	"./cdek.svg": 46545,
	"./dodo_brands.svg": 87798,
	"./evraz.svg": 83972,
	"./lamoda.svg": 42182,
	"./lanit.svg": 70906,
	"./leroy_merlin.svg": 83926,
	"./magnit.svg": 39089,
	"./megafon.svg": 43477,
	"./raiffeisen_bank.svg": 75014,
	"./rolf.svg": 59100,
	"./rusagro.svg": 38150,
	"./skyeng.svg": 31609,
	"./softline.svg": 92077,
	"./sokolov.svg": 4169,
	"./vk.svg": 49612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36603;